<template>
  <div>
    <please-wait-modal/>
    <div class="form-group col-12" v-if="comm_method.name != 'Push Notification'">
      <div class="row px-3">
        <div class="form-check" :class="{'pl-5': index > 0}" v-for="(data,index) in arr_type" :key="'type-'+index">
          <input class="form-check-input" type="radio" name="selected_type" v-model="index_type" :id="'radio_'+data.name" :value="index">
          <label class="form-check-label" :for="'radio_'+data.name">
            Send to {{ data.name }}
          </label>
        </div>
      </div>
    </div>

    <div class="form-group col-12" v-if="arr_type.length > 0 && arr_type[index_type].name == 'Personal'">
      <search-list
        placeholder="Type to Search User"
        :search_url="url_search_user"
        :index_type="index_type"
        @on_selected="on_selected_user"/>
    </div>
    <div class="form-group col-12" v-else-if="arr_type.length > 0 && arr_type[index_type].name == 'Helper category / sub category'">
      <div class="form-group row px-3">
        <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Helper Category</label>
        <select class="form-control col-lg-8" v-model="helper_category" @change="get_helper_sub_category()">
          <option v-for="(data,index) in arr_helper_category" :value="data.id" :key="index">{{ data.name }}</option>
        </select>
      </div>
      <div class="form-group row px-3">
        <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Helper Sub Category</label>
        <select class="form-control col-lg-8" v-model="helper_sub_category">
          <option v-for="(data,index) in arr_helper_sub_category" :value="data.id" :key="index">{{ data.name }}</option>
        </select>
      </div>
    </div>
    <div class="form-group col-12" v-else-if="arr_type.length > 0 && arr_type[index_type].name == 'User Type'">
      <search-list
        placeholder="Type to Search User Type"
        :search_url="url_search_user_type"
        :index_type="index_type"
        @on_selected="on_selected_user_type"/>
    </div>
    <div class="form-group col-12">
      <input type="text" class="form-control" id="form-subject" placeholder="Subject" v-model="subject">
    </div>
    <div class="form-group col-12">
      <textarea class="form-control" id="message" rows="15" name="message" v-model="message"></textarea>
    </div>

    <div class="form-group col-12">
      <div class="row px-3">
        <label for="#form-TLahir" class="col-lg-4 pl-0 m-0 d-flex">Time</label>
        <div class="col-lg-8 p-0 m-0">
          <div class="row px-3">
            <div class="form-check" :class="{'pl-5': index > 0}" v-for="(data,index) in arr_time" :key="'type-'+index">
              <input class="form-check-input" type="radio" name="selected_time" v-model="index_time" :id="'radio_'+data.name" :value="index">
              <label class="form-check-label" :for="'radio_'+data.name">
                {{ data.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group col-12" v-show="selected_time.name == 'Later'">
      <div class="row px-3">
        <label for="#form-TLahir" class="col-lg-4 pl-0 m-0 d-flex">Publish Date</label>
        <div class="col-lg-8 p-0 m-0">
          <div class="row">
            <div class="col">
              <v-date-picker v-model="publish_date"
                locale="id-ID"
                :input-props='{
                  class: "form-control w-100",
                }'
                :min-date="now_date"/>
            </div>
            <div class="col">
              <vue-timepicker
                format="HH:mm"
                v-model="publish_time"
                input-class="w-100"
                :minute-interval="interval_user_publish"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group col-12 text-right">
      <a type="button" class="btn btn-danger" href="/communication">Cancel</a>
      <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#preloader_modal" @click="send">Send</button>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import search_list from '@/pages/communication/search_list'
import 'summernote/dist/summernote.css'
import summernote from 'summernote'

import DatePicker from 'v-calendar/lib/components/date-picker.umd'

import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  components:{
    'v-date-picker': DatePicker,
    'please-wait-modal': please_wait_modal,
    'search-list': search_list,
    VueTimepicker,
  },
  async mounted(){
    await this.get_method()
    await this.get_type()
    await this.get_helper_category()
    await this.get_setting()
    var context = this

    this.manage_time()

    $('#message').summernote({
			height: '250',
			width: '100%',
			callbacks: {
				onChange: function(contents, $editable) {
					context.message = contents
				}
			},
			popover: {
				image: [],
				link: [],
				air: []
			},
			toolbar: [
				['style', ['bold', 'italic', 'underline', 'clear']],
				['font', ['strikethrough', 'superscript', 'subscript']],
				['fontsize', ['fontsize']],
				['color', ['color']],
				['para', ['ul', 'ol', 'paragraph']],
			]
		})
  },
  data(){
    return{
      index_type: 0,
      arr_type: [],
      index_time: 0,
      arr_time: [],
      selected_time: {},
      selected_user: {},
      selected_user_type: {},
      url_search_user: base_url+'/communication/recipient',
      url_search_user_type: base_url+'/communication/type',
      subject: '',
      message: '',
      now_date: new Date(),
      publish_date: '',
      publish_time: '',
      comm_method: {
        name: '',
      },
      helper_category: '',
      arr_helper_category: [],
      helper_sub_category: '',
      arr_helper_sub_category: [],
      interval_user_publish: 1,
    }
  },
  watch:{
    index_type(val){
      this.selected_user = {}
      this.selected_user_type = {}
    },
    index_time(val){
      this.selected_time = this.arr_time[val]
    },
  },
  methods:{
    async send(){
      try{
        if(this.arr_type[this.index_type].name == 'Personal' && this.send_to == '')
          this.$toasted.show('User is empty')
        else if(this.subject == '')
          this.$toasted.show('Subject is empty')
        else if(this.message == '')
          this.$toasted.show('Message is empty')
        else if(this.selected_time.name == 'Later' && this.publish_date == '')
          this.$toasted.show('Publish date is empty')
        else if(this.selected_time.name == 'Later' && this.publish_time == '')
          this.$toasted.show('Publish time is empty')
        else{
          
          var data = {}
          data.subject = this.subject
          data.message = this.message
          data.communication_type = this.arr_type[this.index_type]
          if(this.selected_time.name == 'Later'){
            var date = moment(this.publish_date).format('YYYY-MM-DD')
            data.publish_at = moment(date+' '+this.publish_time).format('YYYY-MM-DD HH:mm:ss')
          }

          var flag = false
          var message = ''
          if(this.arr_type[this.index_type].name == 'Personal'){
            if(this.selected_user.id == null || this.selected_user.id == ''){
              flag = true
              message = 'User not choosen yet'
            }
            data.user = {
              id: this.selected_user.id,
              type: this.selected_user.type,
            }
          }
          else if(this.arr_type[this.index_type].name == 'User Type'){
            if(this.selected_user_type.id == null || this.selected_user_type.id == ''){
              flag = true
              message = 'User type not choosen yet'
            }
            data.type = {
              id: this.selected_user_type.id,
            }
          }
          else if(this.arr_type[this.index_type].name == 'Helper category / sub category'){
            if(this.helper_sub_category == null || this.helper_sub_category == ''){
              flag = true
              message = 'Helper category / sub category not choosen yet'
            }
            data.helper_sub_category = {
              id: this.helper_sub_category,
            }
          }
          data.communication_method = {
            id: this.$route.query.method
          }

          if(!flag){
            $('#please_wait_modal').modal('show')
            var response = await axios.post(base_url+'/communication',data)

            $('#please_wait_modal').modal('hide')
            var response_data = response.data
            if(response_data.status == "success"){
              location.href = '/communication'
            }
            else
              this.$toasted.show(response_data.message)
          }
          else{
            this.$toasted.show(message)
          }
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
    manage_time(){
      var data = {}
      data.name = 'Now'
      this.arr_time.push(data)

      var data = {}
      data.name = 'Later'
      this.arr_time.push(data)
    },
    async on_selected_user(data){
      this.selected_user = data
    },
    async on_selected_user_type(data){
      this.selected_user_type = data
    },
    async get_method(){
      try{
        var response = await axios.get(base_url+'/communication-method?id='+this.$route.query.method)

        var response_data = response.data
        if(response_data.status == "success"){
          this.comm_method = response_data.data
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e.message)
      }
    },
    async get_type(){
      try{
        var response = await axios.get(base_url+'/communication-type/all?type=not_all')

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_type = response_data.data
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e.message)
      }
    },
    async get_setting(){
      try{
        var response = await axios.get(base_url+'/setting')

        var response_data = response.data
        if(response_data.status == "success"){
          this.interval_user_publish = response_data.data.interval_user_publish
          // console.log(moment(response_data.data.publish_date).format('DD/MM/YYYY'))
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    async get_helper_category(){
      try{
        var response = await axios.get(base_url+'/helper-category/all')

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_helper_category = response_data.data
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    async get_helper_sub_category(){
      try{
        var response = await axios.get(base_url+'/helper-sub-category/all?helper_category_id='+this.helper_category)

        var response_data = response.data
        if(response_data.status == "success"){
          this.helper_sub_category = ''
          this.arr_helper_sub_category = response_data.data
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
  }
}
</script>
